import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllOrganizationsUserResponse } from 'domain/models';

interface IOrganizationsState {
  organizationsUser: GetAllOrganizationsUserResponse[];
  loadingOrganizationsUser: boolean;
}

interface IPayloadOrganizationsUser
  extends PayloadAction<GetAllOrganizationsUserResponse[]> {}

const initialState: IOrganizationsState = {
  organizationsUser: [],
  loadingOrganizationsUser: false,
};

export const OrganizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    loadOrganizationsUser: (state, action: IPayloadOrganizationsUser) => {
      state.organizationsUser = action.payload;
    },
    setLoadingOrganizationsUser: (state, action: PayloadAction<boolean>) => {
      state.loadingOrganizationsUser = action.payload;
    },
  },
});

export const { loadOrganizationsUser, setLoadingOrganizationsUser } =
  OrganizationsSlice.actions;

export default OrganizationsSlice.reducer;
